module.exports = __webpack_public_path__ + "img/msteam-addin-thumbnail.25288f8d.png";